/**
 * Opens the browser print dialog, but only once the letterhead artwork has
 * finished loading.
 *
 * Printing immediately is a real race: if the dialog opens before the image has
 * decoded, the first page renders without the letterhead and the official
 * document comes out blank at the top.
 */

const IMAGE_TIMEOUT_MS = 5000;

function waitForImage(image) {
  // complete is true for both a decoded image and a failed one; naturalWidth
  // distinguishes them, and a failure should not block printing forever.
  if (image.complete) return Promise.resolve();

  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      image.removeEventListener('load', finish);
      image.removeEventListener('error', finish);
      resolve();
    };

    image.addEventListener('load', finish);
    image.addEventListener('error', finish);
    // Print anyway rather than trapping the user if the image never resolves.
    setTimeout(finish, IMAGE_TIMEOUT_MS);
  });
}

export async function printSchedule() {
  const images = Array.from(document.querySelectorAll('#print-root img.print-letterhead'));

  if (images.length > 0) {
    await Promise.all(images.map(waitForImage));
    // One frame so the browser applies layout with the decoded images in place.
    await new Promise((resolve) => requestAnimationFrame(() => resolve()));
  }

  window.print();
}

export default printSchedule;
